<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-address-card  text-primary"></i> Hall Ticket</h5>
      </div>
      <hr />
      <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id" @change="listData()">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
        <div class="col-md-3">
          <label class="form-label" for="inputGroupSelect01">Section<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select v-model="Obj.sectionID" class="form-select form-select-sm rounded cursor-pointer" role="button" @change="listData()">
            <option selected=""></option>
            <option v-for="(item, index) in
              secList" :key="index" :value="item._id"> {{ item.Name }} </option>
          </select>
        </div>
        <div class="col-md-3">
          <label for="inputName" class="form-label">Student<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select v-model="Obj.studentID" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option v-for="(item, index) in
              List" :key="index" :value="item._id"> {{ item.firstName }}  {{ item.lastName }}  </option>
          </select>
        </div>
        <div class="col-md-3">
            <label class="form-label">
              Exam Type<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ examList.find(c => c._id === Obj.examtype)?.Name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu">
                <li v-for="(item, index) in examList" :key="index" :value="item.Name">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.examtype = item._id">
                    {{ item.Name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
      </div>
      <div class="col-md-12 text-end mt-2">
        <button class="btn btn-sm btn-success me-1" @click="save"> <i class="fas fa-search text-white"></i> Go </button>
        <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fas fa-times-circle  me-1"></i> Cancel</button>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
    </div>
  </div>
 <div  v-if="showHallticket">
      <div class="col-md-12 mt-3">
  <div class="d-flex justify-content-end align-items-center mb-2 mt-2">
    <div class="d-flex align-items-center gap-1">
      <i class="fa fa-print text-primary cursor-pointer fs-4" role="button" @click="printsection()"></i>
      <i class="fa fa-download fs-4 cursor-pointer me-5" role="button" @click="downloadImage()"></i>
    </div>
  </div>
</div>
  <div class="container-fluid container-a mt-1"  ref="printSection">
    <div class="card border border-1 border-secondary w-100 mt-3">
      <div class="card-body">
        <div class="content">
          <div class="d-flex justify-content-center align-items-center text-center">
            <img :src="getUrl(profile.Image)" alt="School Logo" class="me-2 mb-2 avatar-xl"/>
            <div class="me-5">
              <h2 class="fw-bold mb-0 fs-18">{{ profile.Name }}</h2>
              <p class="mb-0 small fw-bold fs-10">(Recognised by the Govt. of T.S.)</p>
              <p class="mb-0 small fw-bold fs-10">{{ profile.Address }}</p>
              <p class="mb-0 small  fw-bold fs-10">{{ profile.Email }}</p>
              <p class="mb-0 small fw-bold fs-10">+91 {{ profile.MobileNo }}</p>
            </div>
          </div>
            <p class=" text-decoration-underline text-center fs-4 mb-0 fw-bold ms-4 mt-4">HALL TICKET</p>
            <p class="text-center ms-5 fw-bold">{{ examList.find(c => c._id === ExamTypedisplay)?.Name || "" }} Examination {{ currentyear }}  </p>
             <p><strong>Name of the Student </strong>
  <span class="d-inline-block border-bottom border-dark px-5 w-75 ">
    {{ profileData.student?.firstName }} {{ profileData.student?.lastName }}
  </span></p>
             <p><strong>Father's Name </strong><span class="d-inline-block border-bottom border-dark px-5 w-75"> {{ profileData.parent?.fatherName }}</span></p>
              <div class="row w-100">
              <p class="col text-start"><strong>Class</strong>
            <span class="d-inline-block border-bottom border-dark px-5 w-75"> {{clsList.find(cls => cls._id == profileData.student?.clsID)?.name || ''}}</span></p>
              <p class="col text-center"><strong>Section</strong> 
              <span class="d-inline-block border-bottom border-dark px-5 w-50">{{secList.find(sec => sec._id == profileData.student?.sectionID)?.Name || '' }}</span></p>
              <p class="col text-end"><strong>Roll No.</strong>
              <span class="d-inline-block border-bottom border-dark px-5 w-50"> {{ profileData.student?.rollNo }}</span></p>
              </div>
               <div class="row w-100"><div class="col-auto"> <p class="text-start fw-bold mb-0">Subject</p> </div>
                <div class="col table-responsive"> <table class="table table-bordered custom-table mb-0 w-100">
               <thead>
               <tr>
                 <th>I<sup>st</sup>Language</th>
                 <th>II<sup>nd</sup>Language</th>
                 <th>III<sup>rd</sup>Language</th>
                 <th>Maths</th>
                 <th>Science</th>
                 <th>SocialStudies</th>
                 <th>Computer/G.K</th>
              </tr>
             </thead>
            <tbody>
            <tr>
              <td class="p-4"></td> <td></td> <td></td> <td></td> <td></td> <td></td> <td></td>
            </tr>
            </tbody>
           </table>
           </div>
          </div>
          <div class="row w-100 mt-5">
            <p class="col text-start fw-bold">Class Teacher<span class="d-inline-block border-bottom border-dark px-5 w-50"></span></p>
            <p class="col text-center fw-bold">Incharge</p>
          <p class="col text-end fw-bold">Head of the Institution</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import {  api } from '@/utils/helpers.js';
import { ref, computed, nextTick } from 'vue'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
 import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList,examList, profile} = schoolStore();
const printSection = ref(null)
const Obj = ref({ clsID: "", sectionID: "", studentID: "",examtype: "", })
const List= ref([])
const profileData= ref([])
const ExamTypedisplay = ref("");
const showHallticket = ref(false)
const msgObj = ref({ msg: "", role: "", show: false, })
const errors = ref({})
const errors1 = ref({})
const downloadImage = async () => {
  const modalElement = printSection.value;
  if (!modalElement) return;
  const clone = modalElement.cloneNode(true);
  clone.style.width = "900px"; 
  clone.style.maxWidth = "900px";
  clone.style.fontSize = "14px"; 
  clone.style.background = "#fff";
  clone.style.position = "absolute";
  clone.style.left = "-9999px"; 
  document.body.appendChild(clone);
  try {
    const canvas = await html2canvas(clone, { scale: 2, useCORS: true, windowWidth: 900, });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4", });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = (canvas.height * pageWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pageWidth, pageHeight);
    const studentName = `${profileData.value.student?.firstName || ''}-${profileData.value.student?.lastName || ''}` .trim() .replace(/\s+/g, "-");
    pdf.save(`${studentName || "hall-ticket"}-Hallticket.pdf`);
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    document.body.removeChild(clone); 
  }
};
const currentyear = computed(() => {
  const today = new Date();
  const month = today.getMonth(); 
  const year = today.getFullYear();
  if (month >= 5) { return `${year}-${year + 1}`; }
   else { return `${year - 1}-${year}`; }
});
const printsection = async () => {
  await nextTick();
  window.print();
};
const listData= async()=> {
      const fields = {
        clsID: { value: Obj.value.clsID, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], }
      };
      errors1.value = validateForm(fields);
      if (Object.keys(errors1.value).length === 0) {
        await api .get(`/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}`)
        .then((res) => { List.value = res.data });
      }
    }
    const save= async()=> {
       const fields = {
        Class: { value: Obj.value.clsID, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], },
        Student: { value: Obj.value.studentID, validators: [isRequired], },
        ExamType: { value: Obj.value.examtype, validators: [isRequired], }
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
      if (!Obj.value.studentID) {  
        msgObj.value = { msg: "Please select a student", role: "danger", show: true };
        return;
      }
      await api.get(`/students/${Obj.value.studentID}`)
        .then((res) => {
          profileData.value = res.data;
          ExamTypedisplay.value = Obj.value.examtype;
          showHallticket.value = true;
        });
    }
  }
    const reset= async()=> {
      Obj.value = { Class: "", Section: "", Student: "", examtype:"", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
      List.value = []; 
      showHallticket.value = false;
    } 
    const getUrl = (img) => {
  let imgUrl = !img
    ? "/images/Logo.png"
    : img.startsWith("..")
      ? img.substring(2)
      : img;
 
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
</script>
<style>
@media (max-width: 375px) {
.container-fluid {
  overflow-x: auto;
}

.container-a {
  min-width: 900px;
}
}
@media print {
  body * {
    visibility: hidden !important;
  }
  .card,
  .card * {
    visibility: visible !important;
  }
 .card {
    position: absolute;
    left:0;
    top: 0;
    width: 101%;
    height: 500px;
    z-index: 9999;
    background-color: white;
    border: 1px solid #ddd;
    padding:6px;
    overflow: hidden;
  }
  .table{
    margin-left:-13px;
  }
 .ms-2{
  margin-left:110px!important;
 }
}
</style>